// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { IconWrapper } from "@insite/mobius/Icon";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import { linkListStyles } from "@rpsc/Overrides/Widgets/Basic/SocialLinks";
import { fontConfig } from "@rpsc/XDL/PreStyle/typography";
import { getSystemColor, xScreen } from "@rpsc/XDL/Utilities";
import { css } from "styled-components";

linkListStyles.socialLinkListWrapper = {
    css: css`
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        gap: 5px;
    `,
};

linkListStyles.link = {
    typographyProps: {
        size: 12,
        lineHeight: "14px",
        weight: fontConfig.weight.regular,
    },
    css: css`
        gap: 0;
        ${TypographyStyle} {
            color: ${({ titleColor }: any) => titleColor || getSystemColor("primary")};
        }
        &:hover {
            ${IconWrapper}, svg {
                color: ${({ iconColor }: any) => iconColor || getSystemColor("common.ui8")};
            }
            ${TypographyStyle} {
                color: ${({ titleColor }: any) => titleColor || getSystemColor("primary")};
                opacity: 0.5;
            }
        }
    `,
};

linkListStyles.titleText = {
    color: "common.ui1",
    size: 14,
    weight: fontConfig.weight.bold,
};

linkListStyles.wrapper = {
    css: css`
        border-radius: 4px;
        display: flex;
        flex-direction: column;
        gap: 8px;
        ${xScreen("lte", "md")} {
            max-width: 232px;
        }
        ${xScreen("lte", "xs")} {
            max-width: 240px;
        }
    `,
};
